<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Checkbox, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';
	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id);
	let checked = settings.rain_sensor,
		waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const res = await postReq(`/device/sensor/settings/rain_mode`, {
			id,
			rain_mode: Number(checked),
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Checkbox size="m" class="mb-s" bind:checked id="checkbox-0tgth19"
	>{$format('rain_mode_description', {
		default:
			'In this mode, the device will not alarm when there is water and will report when the water status has changed.',
	})}</Checkbox
>

<Button loading={waitForResponse} size="m" class="text-uppercase" width="full" on:click={save}
	>{$format('button_apply', { default: 'apply' })}</Button
>
